import styled from "styled-components";
import colors from "../../../../styles/colors";

export const GenericWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding-top: 10px;
    
    
    & h1, h2, h3, h4, h5, h6 {
        margin: 0;
        font-size: 10px;
        text-align: center;
        color: white;
    } 
`;

export const GenericContainerCard = styled.div`
    position: relative;
    width: 95%;
    height: 120px;
    border-radius: 10px;
    border: 2px solid white;
    background-color: ${colors.bgColorBordeaux};
`;